module.exports = __webpack_public_path__ + "static/105027370_662804887911152_3816438750528212538_o_optimized-e27449b17e24082d5c70bddfb035e015.jpg";